// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Context = require("./Context.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Type_String = require("../type/Type_String.bs.js");
var Util_Config = require("../util/Util_Config.bs.js");
var Context_Config = require("./Context_Config.bs.js");
var FeatureFlipping = require("../FeatureFlipping.bs.js");

function initialState(playStoreUrl, appGalleryUrl, api, baseUrl, cdnUrl, createVideoElement, featureFlippings, appStoreUrl, trackPixel, trackPageView, trackUserAction, vodStoreHomepageUrl, serverTime, ssoApiKey, ssoTokenApiKey) {
  return Context.Config.make(/* Initialized */0, {
              api: api,
              baseUrl: baseUrl,
              cdnUrl: Curry._1(Type_String.CdnUrl.make, cdnUrl),
              createVideoElement: createVideoElement,
              featureFlippings: featureFlippings,
              trackPixel: trackPixel,
              trackUserAction: trackUserAction,
              trackPageView: trackPageView,
              vodStoreHomepageUrl: vodStoreHomepageUrl,
              playStoreUrl: playStoreUrl,
              appStoreUrl: appStoreUrl,
              appGalleryUrl: appGalleryUrl,
              serverTime: serverTime,
              ssoApiKey: ssoApiKey,
              ssoTokenApiKey: ssoTokenApiKey
            });
}

function Provider_Config(Props) {
  var cdnUrl = Props.cdnUrl;
  var baseUrl = Props.baseUrl;
  var api = Props.api;
  var children = Props.children;
  var trackPixel = Props.trackPixel;
  var trackPageView = Props.trackPageView;
  var trackUserAction = Props.trackUserAction;
  var ssoApiKey = Props.ssoApiKey;
  var ssoTokenApiKey = Props.ssoTokenApiKey;
  var featureFlippings = Props.featureFlippings;
  var vodStoreHomepageUrl = Props.vodStoreHomepageUrl;
  var createVideoElement = Props.createVideoElement;
  var playStoreUrl = Props.playStoreUrl;
  var appStoreUrl = Props.appStoreUrl;
  var appGalleryUrl = Props.appGalleryUrl;
  var serverTime = Props.serverTime;
  var emacVersion = Belt_Option.mapWithDefault(featureFlippings, "v3", (function (param) {
          return param.emacVersion;
        }));
  var serverTime$1 = Belt_Option.mapWithDefault(serverTime, new Date(), (function (prim) {
          return new Date(prim);
        }));
  var ensuredApi = Context_Config.ensureApi(undefined, emacVersion, api);
  var ensuredVodStoreHomepageUrl = Context_Config.Helpers.ensureVodStoreHomepageUrl(vodStoreHomepageUrl);
  var ensuredFeatureFlipping = FeatureFlipping.make(featureFlippings);
  var ensuredPlayStoreUrl = Context_Config.Helpers.ensurePlayStoreUrl(playStoreUrl);
  var ensuredAppStoreUrl = Context_Config.Helpers.ensureAppStoreUrl(appStoreUrl);
  var ensuredAppGalleryUrl = Context_Config.Helpers.ensureAppGalleryUrl(appGalleryUrl);
  var ssoApiKey$1 = Belt_Option.getWithDefault(ssoApiKey, "");
  var ssoTokenApiKey$1 = Belt_Option.getWithDefault(ssoTokenApiKey, "");
  var state = initialState(ensuredPlayStoreUrl, ensuredAppGalleryUrl, ensuredApi, baseUrl, Belt_Option.getWithDefault(cdnUrl, Util_Config.latestCdnUrl), createVideoElement, ensuredFeatureFlipping, ensuredAppStoreUrl, trackPixel, trackPageView, trackUserAction, ensuredVodStoreHomepageUrl, serverTime$1, ssoApiKey$1, ssoTokenApiKey$1);
  return React.createElement(Context.Config.Context.Provider.make, {
              value: [
                state,
                (function (param) {
                    
                  })
              ],
              children: children
            });
}

var make = Provider_Config;

exports.initialState = initialState;
exports.make = make;
/* react Not a pure module */
